export const BASE_PREFILL_FIELDS = ['firstName', 'lastName', 'email', 'date', 'time'] as const;

export const GENERAL_BASED_PREFILL_FIELDS = [
  ...BASE_PREFILL_FIELDS,
  'defaultOffice', // shown in user profile & home page
  'dateOfThatDay',
] as const;

export const WORKDAY_BASED_PREFILL_FIELDS = [
  ...BASE_PREFILL_FIELDS,
  'officeBooked', // only shown when user booked an Office day (that day)
  'workspaceBooked',
  'date',
] as const;

export const EVENT_BASED_PREFILL_FIELDS = [
  ...BASE_PREFILL_FIELDS,
  'officeBooked', // priority based on office booked that day or building room(s)
  'dateAndTimeEventPlanned',
  'numberOfInvitees',
] as const;

export const LOCATION_BASED_PREFILL_FIELDS = [...BASE_PREFILL_FIELDS, 'locationName', 'office', 'date'] as const;

export const PREFILL_FIELDS_BY_CATEGORY = {
  General: GENERAL_BASED_PREFILL_FIELDS,
  EventBased: EVENT_BASED_PREFILL_FIELDS,
  WorkdayBased: WORKDAY_BASED_PREFILL_FIELDS,
  LocationBased: LOCATION_BASED_PREFILL_FIELDS,
} as const;

export type AllPrefillFields =
  | (typeof GENERAL_BASED_PREFILL_FIELDS)[number]
  | (typeof WORKDAY_BASED_PREFILL_FIELDS)[number]
  | (typeof EVENT_BASED_PREFILL_FIELDS)[number]
  | (typeof LOCATION_BASED_PREFILL_FIELDS)[number];
